import React from 'react';
import { Check } from 'lucide-react';

const SuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-overlayFade">
      <div className="bg-surface-container rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl transform animate-popIn border border-outline-variant/20">
        {/* Ícone de sucesso */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-primary-container rounded-full flex items-center justify-center animate-iconPulse animate-pulse-glow" style={{ animationDelay: '50ms' }}>
            <Check className="w-8 h-8 text-primary" />
          </div>
        </div>

        {/* Título */}
        <h2 className="text-2xl font-headline font-bold text-on-surface text-center mb-3 animate-slideUp" style={{ animationDelay: '120ms' }}>
          Agradecemos seu contato!
        </h2>

        {/* Subtítulo */}
        <p className="text-on-surface-variant text-center mb-8 text-base animate-slideUp" style={{ animationDelay: '200ms' }}>
          Responderemos em até 2 horas.
        </p>

        {/* Botão Fechar */}
        <div className="flex justify-center">
          <button
            onClick={onClose}
            className="bg-primary hover:opacity-90 text-on-primary font-semibold px-8 py-3 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 hover:scale-105 active:scale-95 shadow-md hover:shadow-lg"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;